/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/332-sort-numberic-desc': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 12V0H3v12H.5L4 15.5 7.5 12H5zM13.5 16a.5.5 0 01-.5-.5V10h-.5a.5.5 0 010-1h1a.5.5 0 01.5.5v6a.5.5 0 01-.5.5zM14.5 0h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H14v2h-2.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zM12 1h2v2h-2V1z"/>'
  }
})
